/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { tenantsDeleteApiKey } from "../../funcs/tenantsDeleteApiKey.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdRequest$inboundSchema,
};

export const tool$tenantsDeleteApiKey: ToolDefinition<typeof args> = {
  name: "tenants_delete-api-key",
  description: `Delete tenant API key

Permanently deletes a tenant API key`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsDeleteApiKey(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
